// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exchange-page-layout {
  display: flex;
  min-height: 100vh;
  background: #fff;
  gap: 0;
}

/* LEFT SECTION - EXCHANGE FORM */
.exchange-left-section {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #fff;
  border-right: 1px solid #e3e3e3;
  overflow-y: auto;
}

/* RIGHT SECTION - COIN TABLE */
.exchange-right-section {
  width: 50%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px;
  background: #fafafa;
  overflow-y: auto;
}

/* EXCHANGE FORM ADJUSTMENTS */
.exchange-left-section .form-page {
  display: flex;
  flex-direction: column;
  min-height: auto;
  background: transparent;
  width: auto;
  max-width: 400px;
}

.exchange-left-section .left-card {
  display: none;
}

.exchange-left-section .right-block {
  width: 100%;
  padding: 0;
}

.exchange-left-section .step-card {
  padding: 0;
  width: 100%;
  justify-self: start;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */
  border-radius: 12px;
  padding: 24px;
}

.exchange-left-section .step-title {
  font-size: 20px;
  margin-bottom: 20px;
}

/* COIN TABLE ADJUSTMENTS */
.exchange-right-section .coin-table-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.exchange-right-section .table-title {
  font-size: 24px;
  text-align: left;
  margin-bottom: 24px;
}

/* RESPONSIVE */
@media (max-width: 1200px) {
  .exchange-left-section {
    width: 45%;
    padding: 30px;
  }

  .exchange-right-section {
    width: 55%;
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .exchange-page-layout {
    flex-direction: column;
    gap: 0;
  }


  .exchange-left-section {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #e3e3e3;
    padding: 24px;
  }
.exchange-left-section .step-card {
  padding: 0;
  justify-self: center;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */
  border-radius: 12px;
  background-color: red;
  padding: 24px;
}
  .exchange-right-section {
    width: 100%;
    padding: 24px;
    background: #fff;
  }

}



.exchange-section-wrapper {
  /* background: #f8fafc; Светлый фон для контраста с белыми карточками */
  padding: 60px 20px;
}

.exchange-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr; /* Две равные колонки */
  gap: 30px; /* Расстояние между блоками */
}

.exchange-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); /* Мягкая тень */
  height: fit-content;
}

/* Адаптивность для планшетов и мобилок */
@media (max-width: 1024px) {
  .exchange-container {
    grid-template-columns: 1fr; /* Блоки встают друг под друга */
    max-width: 600px;
  }
  
  .exchange-section-wrapper {
    padding: 40px 15px;
  }
}

@media (max-width: 480px) {
  .exchange-card {
    padding: 2px;
    border-radius: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/ExchangePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;AACR;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;;;EAGA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;EACf;AACF;EACE,UAAU;EACV,oBAAoB;EACpB,+CAA+C;EAC/C,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;AAEF;;;;AAIA;EACE,uEAAuE;EACvE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B,EAAE,uBAAuB;EACvD,SAAS,EAAE,6BAA6B;AAC1C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C,EAAE,gBAAgB;EAC7D,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B,EAAE,gCAAgC;IAC5D,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":[".exchange-page-layout {\n  display: flex;\n  min-height: 100vh;\n  background: #fff;\n  gap: 0;\n}\n\n/* LEFT SECTION - EXCHANGE FORM */\n.exchange-left-section {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: #fff;\n  border-right: 1px solid #e3e3e3;\n  overflow-y: auto;\n}\n\n/* RIGHT SECTION - COIN TABLE */\n.exchange-right-section {\n  width: 50%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 40px;\n  background: #fafafa;\n  overflow-y: auto;\n}\n\n/* EXCHANGE FORM ADJUSTMENTS */\n.exchange-left-section .form-page {\n  display: flex;\n  flex-direction: column;\n  min-height: auto;\n  background: transparent;\n  width: auto;\n  max-width: 400px;\n}\n\n.exchange-left-section .left-card {\n  display: none;\n}\n\n.exchange-left-section .right-block {\n  width: 100%;\n  padding: 0;\n}\n\n.exchange-left-section .step-card {\n  padding: 0;\n  width: 100%;\n  justify-self: start;\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.exchange-left-section .step-title {\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n/* COIN TABLE ADJUSTMENTS */\n.exchange-right-section .coin-table-container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.exchange-right-section .table-title {\n  font-size: 24px;\n  text-align: left;\n  margin-bottom: 24px;\n}\n\n/* RESPONSIVE */\n@media (max-width: 1200px) {\n  .exchange-left-section {\n    width: 45%;\n    padding: 30px;\n  }\n\n  .exchange-right-section {\n    width: 55%;\n    padding: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .exchange-page-layout {\n    flex-direction: column;\n    gap: 0;\n  }\n\n\n  .exchange-left-section {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid #e3e3e3;\n    padding: 24px;\n  }\n.exchange-left-section .step-card {\n  padding: 0;\n  justify-self: center;\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */\n  border-radius: 12px;\n  background-color: red;\n  padding: 24px;\n}\n  .exchange-right-section {\n    width: 100%;\n    padding: 24px;\n    background: #fff;\n  }\n\n}\n\n\n\n.exchange-section-wrapper {\n  /* background: #f8fafc; Светлый фон для контраста с белыми карточками */\n  padding: 60px 20px;\n}\n\n.exchange-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Две равные колонки */\n  gap: 30px; /* Расстояние между блоками */\n}\n\n.exchange-card {\n  background: #ffffff;\n  border-radius: 24px;\n  padding: 30px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05); /* Мягкая тень */\n  height: fit-content;\n}\n\n/* Адаптивность для планшетов и мобилок */\n@media (max-width: 1024px) {\n  .exchange-container {\n    grid-template-columns: 1fr; /* Блоки встают друг под друга */\n    max-width: 600px;\n  }\n  \n  .exchange-section-wrapper {\n    padding: 40px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .exchange-card {\n    padding: 2px;\n    border-radius: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
